var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"checkbox"},[_c('button',{class:_vm.checkboxClass,on:{"click":_vm.selectItem}},[_c('i',{staticClass:"mdi mdi-check"})]),_vm._v("\n    "+_vm._s(_vm.option.label)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }